<!--
  ServiceChip — vocabolario unico dei SERVIZI.

  ATTENZIONE ai nomi: l'etichetta mostrata all'utente NON coincide con il
  valore salvato a database. La mappatura sta qui, in un posto solo:

      UI "Notturno"            -> DB 'restaurant'
      UI "Transfer"            -> DB 'escort' / 'escort_loaner'
      UI "Spostamento interno" -> DB 'journey'
      UI "Pickup & Delivery"   -> DB 'pickup' / 'pickup_loaner'

  Uso:  <ServiceChip service="restaurant" />        (passa il valore DB)
        <ServiceChip service="pickup" label="Pickup A/R" />  (etichetta custom)
-->
<template>
  <span
    class="chip"
    :class="`chip--${tone}`"
  >{{ label || defaultLabel }}</span>
</template>

<script>
// Mappa valore-DB -> { tono grafico, etichetta italiana }.
const SERVICE_MAP = {
  pickup: { tone: 'pickup', label: 'Pickup & Delivery' },
  pickup_loaner: { tone: 'pickup', label: 'Pickup · auto cortesia' },
  journey: { tone: 'fleet', label: 'Spostamento interno' },
  route: { tone: 'fleet', label: 'Spostamento interno' },
  restaurant: { tone: 'notturno', label: 'Notturno' },
  escort: { tone: 'transfer', label: 'Transfer' },
  escort_loaner: { tone: 'transfer', label: 'Transfer · auto cortesia' },
};

export default {
  name: 'ServiceChip',
  props: {
    // Valore del DB (type_prenotazione / type_booking) oppure alias UI.
    service: {
      type: String,
      required: true,
    },
    // Sovrascrive l'etichetta di default (es. per aggiungere "A/R").
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    entry() {
      return SERVICE_MAP[this.service] || { tone: 'muted', label: this.service };
    },
    tone() {
      return this.entry.tone;
    },
    defaultLabel() {
      return this.entry.label;
    },
  },
};
</script>

<style scoped>
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 650;
  line-height: 1.5;
  white-space: nowrap;
  width: max-content;
}
.chip::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}
/* Pickup: il lime resta riempimento, il testo usa l'oliva scuro (leggibilità). */
.chip--pickup {
  color: var(--svc-pickup-ink);
  background: var(--svc-pickup-bg);
}
.chip--fleet {
  color: var(--svc-fleet);
  background: var(--svc-fleet-bg);
}
.chip--notturno {
  color: var(--svc-notturno);
  background: var(--svc-notturno-bg);
}
.chip--transfer {
  color: var(--svc-transfer);
  background: var(--svc-transfer-bg);
}
.chip--muted {
  color: var(--state-muted);
  background: var(--state-muted-bg);
}
</style>
